define(["require", "exports", "tslib", "esri/core/watchUtils", "esri/core/promiseUtils", "esri/core/Handles", "esri/layers/GraphicsLayer", "esri/tasks/support/IdentifyParameters", "esri/tasks/IdentifyTask", "esri/geometry", "esri/widgets/Popup", "esri/core/promiseUtils", "../utilites/geometryUtils", "../utilites/geometryUtils"], function (require, exports, tslib_1, watchUtils_1, promiseUtils_1, Handles_1, GraphicsLayer_1, IdentifyParameters_1, IdentifyTask_1, geometry_1, Popup_1, promiseUtils_2, geometryUtils_1, geometryUtils_2) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.addScaleBar = exports.addLegend = exports.addHome = exports.addBasemap = exports.addZoom = exports.addMapComponents = void 0;
    Handles_1 = tslib_1.__importDefault(Handles_1);
    GraphicsLayer_1 = tslib_1.__importDefault(GraphicsLayer_1);
    IdentifyParameters_1 = tslib_1.__importDefault(IdentifyParameters_1);
    IdentifyTask_1 = tslib_1.__importDefault(IdentifyTask_1);
    Popup_1 = tslib_1.__importDefault(Popup_1);
    function addMapComponents(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var config;
            return tslib_1.__generator(this, function (_a) {
                config = props.config;
                this._handles = new Handles_1.default();
                this._handles.add([watchUtils_1.init(config, ["home", "homePosition"], function (newValue, oldValue, propertyName) {
                        props.propertyName = propertyName;
                        addHome(props);
                    }),
                    watchUtils_1.init(config, ["mapZoom", "mapZoomPosition"], function (newValue, oldValue, propertyName) {
                        props.propertyName = propertyName;
                        addZoom(props);
                    }),
                    watchUtils_1.init(config, ["legend", "legendPosition", "legendOpenAtStart"], function (newValue, oldValue, propertyName) {
                        props.propertyName = propertyName;
                        addLegend(props);
                    }),
                    watchUtils_1.init(config, ["scalebar", "scalebarPosition"], function (newValue, oldValue, propertyName) {
                        props.propertyName = propertyName;
                        addScaleBar(props);
                    }),
                    watchUtils_1.init(config, ["nextBasemap", "basemapTogglePosition", "basemapToggle"], function (newValue, oldValue, propertyName) {
                        props.propertyName = propertyName;
                        addBasemap(props);
                    })], "configuration");
                if (!config.withinConfigurationExperience) {
                    this._handles.remove("configuration");
                }
                return [2 /*return*/];
            });
        });
    }
    exports.addMapComponents = addMapComponents;
    function addZoom(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var view, config, propertyName, mapZoom, mapZoomPosition, Zoom, node;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        view = props.view, config = props.config, propertyName = props.propertyName;
                        mapZoom = config.mapZoom, mapZoomPosition = config.mapZoomPosition;
                        return [4 /*yield*/, new Promise(function (resolve_1, reject_1) { require(["esri/widgets/Zoom"], resolve_1, reject_1); }).then(tslib_1.__importStar)];
                    case 1:
                        Zoom = _a.sent();
                        node = _findNode("esri-zoom");
                        if (!mapZoom) {
                            if (node)
                                view.ui.remove(node);
                            return [2 /*return*/];
                        }
                        if (node && !mapZoom)
                            view.ui.remove(node);
                        if (propertyName === "mapZoomPosition" && node) {
                            view.ui.move(node, mapZoomPosition);
                        }
                        else if (propertyName === "mapZoom" && !node) {
                            view.ui.add(new Zoom.default({ view: view }), mapZoomPosition);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    exports.addZoom = addZoom;
    function addBasemap(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var view, config, propertyName, nextBasemap, basemapTogglePosition, basemapToggle, BasemapToggle, BasemapLayerList, node, bmToggle, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        view = props.view, config = props.config, propertyName = props.propertyName;
                        nextBasemap = config.nextBasemap, basemapTogglePosition = config.basemapTogglePosition, basemapToggle = config.basemapToggle;
                        return [4 /*yield*/, new Promise(function (resolve_2, reject_2) { require(["esri/widgets/BasemapToggle"], resolve_2, reject_2); }).then(tslib_1.__importStar)];
                    case 1:
                        BasemapToggle = _b.sent();
                        return [4 /*yield*/, new Promise(function (resolve_3, reject_3) { require(["esri/widgets/BasemapLayerList"], resolve_3, reject_3); }).then(tslib_1.__importStar)];
                    case 2:
                        BasemapLayerList = _b.sent();
                        if (!BasemapToggle)
                            return [2 /*return*/];
                        node = _findNode("esri-basemap-toggle");
                        // If basemapToggle isn't enabled remove the widget if it exists and exit 
                        if (!basemapToggle) {
                            if (node)
                                view.ui.remove(node);
                            return [2 /*return*/];
                        }
                        // Move the basemap toggle widget if it exists 
                        if (propertyName === "basemapTogglePosition" && node) {
                            view.ui.move(node, basemapTogglePosition);
                        }
                        if (!(propertyName === "basemapToggle" || (propertyName === "nextBasemap" && node))) return [3 /*break*/, 5];
                        if (node)
                            view.ui.remove(node);
                        bmToggle = new BasemapToggle.default({
                            view: view
                        });
                        if (!nextBasemap) return [3 /*break*/, 4];
                        _a = bmToggle;
                        return [4 /*yield*/, _getBasemap(nextBasemap)];
                    case 3:
                        _a.nextBasemap = (_b.sent());
                        _b.label = 4;
                    case 4:
                        view.ui.add(bmToggle, basemapTogglePosition);
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    exports.addBasemap = addBasemap;
    function _getBasemap(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Basemap, basemap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, new Promise(function (resolve_4, reject_4) { require(["esri/Basemap"], resolve_4, reject_4); }).then(tslib_1.__importStar)];
                    case 1:
                        Basemap = _a.sent();
                        if (!Basemap) {
                            return [2 /*return*/];
                        }
                        basemap = Basemap.default.fromId(id);
                        if (!!basemap) return [3 /*break*/, 3];
                        return [4 /*yield*/, new Basemap.default({
                                portalItem: {
                                    id: id
                                }
                            }).loadAll()];
                    case 2:
                        basemap = _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/, basemap];
                }
            });
        });
    }
    function addHome(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var view, config, propertyName, home, homePosition, Home, node;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        view = props.view, config = props.config, propertyName = props.propertyName;
                        home = config.home, homePosition = config.homePosition;
                        return [4 /*yield*/, new Promise(function (resolve_5, reject_5) { require(['esri/widgets/Home'], resolve_5, reject_5); }).then(tslib_1.__importStar)];
                    case 1:
                        Home = _a.sent();
                        node = _findNode("esri-home");
                        if (!home) {
                            if (node)
                                view.ui.remove(node);
                            return [2 /*return*/];
                        }
                        if (node && !home)
                            view.ui.remove(node);
                        if (propertyName === "homePosition" && node) {
                            view.ui.move(node, homePosition);
                        }
                        else if (propertyName === "home") {
                            view.ui.add(new Home.default({ view: view }), homePosition);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    exports.addHome = addHome;
    function addLegend(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var view, config, propertyName, legend, legendPosition, legendOpenAtStart, modules, _a, Legend, Expand, LayerList, Print, Measurement, BasemapLayerList, Sketch, BasemapGallery, PortalBasemapsSource, node, layerListContent, legendExpand, printContent, printExpand, sketchLayer_1, sketchContent_1, sketchExpand_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        view = props.view, config = props.config, propertyName = props.propertyName;
                        legend = config.legend, legendPosition = config.legendPosition, legendOpenAtStart = config.legendOpenAtStart;
                        return [4 /*yield*/, promiseUtils_1.eachAlways([new Promise(function (resolve_6, reject_6) { require(["esri/widgets/Legend"], resolve_6, reject_6); }).then(tslib_1.__importStar), new Promise(function (resolve_7, reject_7) { require(["esri/widgets/Expand"], resolve_7, reject_7); }).then(tslib_1.__importStar), new Promise(function (resolve_8, reject_8) { require(["esri/widgets/LayerList"], resolve_8, reject_8); }).then(tslib_1.__importStar), new Promise(function (resolve_9, reject_9) { require(["esri/widgets/Print"], resolve_9, reject_9); }).then(tslib_1.__importStar), new Promise(function (resolve_10, reject_10) { require(["esri/widgets/Measurement"], resolve_10, reject_10); }).then(tslib_1.__importStar), new Promise(function (resolve_11, reject_11) { require(["esri/widgets/BasemapLayerList"], resolve_11, reject_11); }).then(tslib_1.__importStar), new Promise(function (resolve_12, reject_12) { require(["esri/widgets/Sketch"], resolve_12, reject_12); }).then(tslib_1.__importStar), new Promise(function (resolve_13, reject_13) { require(["esri/widgets/BasemapGallery"], resolve_13, reject_13); }).then(tslib_1.__importStar), new Promise(function (resolve_14, reject_14) { require(["esri/widgets/BasemapGallery/support/PortalBasemapsSource"], resolve_14, reject_14); }).then(tslib_1.__importStar)])];
                    case 1:
                        modules = _b.sent();
                        _a = tslib_1.__read(modules.map(function (module) { return module.value; }), 9), Legend = _a[0], Expand = _a[1], LayerList = _a[2], Print = _a[3], Measurement = _a[4], BasemapLayerList = _a[5], Sketch = _a[6], BasemapGallery = _a[7], PortalBasemapsSource = _a[8];
                        node = view.ui.find("legendExpand");
                        if (!legend) {
                            if (node)
                                view.ui.remove(node);
                            return [2 /*return*/];
                        }
                        // move the node if it exists ex
                        if (propertyName === "legendPosition" && node) {
                            view.ui.move(node, legendPosition);
                        }
                        else if (propertyName === "legend") {
                            layerListContent = new LayerList.default({
                                style: {
                                    type: 'card'
                                },
                                view: view,
                                listItemCreatedFunction: function (event) {
                                    var item = event.item;
                                    if (item.layer.type == "feature" || item.layer.type == "graphics") {
                                        item.layer.listMode = "hide";
                                    }
                                    else if (item.layer.type == "map-image") {
                                        // don't show legend twice
                                        item.panel = {
                                            content: "legend",
                                            open: false
                                        };
                                    }
                                }
                            });
                            legendExpand = new Expand.default({
                                id: "legendExpand",
                                expandTooltip: "Layers",
                                content: layerListContent,
                                mode: "floating",
                                group: legendPosition,
                                view: view
                            });
                            printContent = new Print.default({
                                style: {
                                    type: 'card'
                                },
                                view: view,
                                printServiceUrl: config.print.printServiceUrl
                            });
                            printExpand = new Expand.default({
                                id: "printExpand",
                                expandTooltip: "Print",
                                content: printContent,
                                mode: "floating",
                                group: legendPosition,
                                view: view
                            });
                            sketchLayer_1 = new GraphicsLayer_1.default({ id: "SketchToolGraphicsLayer" });
                            view.map.layers.add(sketchLayer_1);
                            sketchContent_1 = new Sketch.default({
                                style: {
                                    type: 'card'
                                },
                                view: view,
                                iconClass: "esri-icon-description",
                                layer: sketchLayer_1,
                                // graphic will be selected as soon as it is created
                                creationMode: "single",
                                defaultUpdateOptions: {
                                    enableRotation: false,
                                    multipleSelectionEnabled: false,
                                    toggleToolOnClick: false
                                }
                            });
                            sketchContent_1.on("create", function (event) {
                                if (event.state === "complete") {
                                    sketchExpand_1.expand();
                                    sketchCompleted(sketchContent_1, event, view);
                                }
                            });
                            sketchContent_1.on("delete", function (event) {
                                if (sketchLayer_1.graphics.find(function (g) { return g === view.popup.selectedFeature; })) {
                                    view.popup.close();
                                }
                                sketchLayer_1.graphics.removeAll();
                            });
                            sketchContent_1.viewModel.updateOnGraphicClick = false;
                            sketchExpand_1 = new Expand.default({
                                id: "sketchExpand",
                                expandTooltip: "Identify",
                                content: sketchContent_1,
                                mode: "floating",
                                group: "bottom-right",
                                view: view
                            });
                            sketchExpand_1.watch("expanded", function (newValue, oldValue) {
                                if (newValue === false) {
                                    sketchContent_1.layer.graphics.removeAll();
                                    sketchContent_1.delete();
                                }
                            });
                            // view.map.basemap.baseLayers.forEach(l => {
                            // 	if(l.title == "Streets Indy" || l.title == "World_Street_Map"){
                            // 		l.visible = true;
                            // 	}else{
                            // 		l.visible = false;
                            // 	}
                            // 	l.watch("visible", vis => {
                            // 		var bl:any = basemapLayerListContent.baseItems.find(i => i.title == l.title);
                            // 		console.log(bl.actionsSections);
                            // 		if(vis == true){
                            // 			bl.actionsSections = [
                            // 				[
                            // 					{
                            // 						title: "Increase opacity",
                            // 						className: "esri-icon-up",
                            // 						id: "increase-opacity"
                            // 					},
                            // 					{
                            // 						title: "Opacity: " + bl.layer.opacity*100 + "%"
                            // 					},
                            // 					{
                            // 						title: "Decrease opacity",
                            // 						className: "esri-icon-down",
                            // 						id: "decrease-opacity"
                            // 					}
                            // 				]
                            // 			];
                            // 		}else{
                            // 			bl.actionsSections = [];
                            // 		}
                            // 	});
                            // });
                            // basemapLayerListContent.on("trigger-action", event => {
                            // 	var bl:any = view.map.basemap.baseLayers.find(r => r.title == event.item.title);
                            // 	if(event.action.id == "decrease-opacity"){
                            // 		if(bl.opacity > 0){
                            // 			bl.opacity -= 0.25;
                            // 		}
                            // 	}else if(event.action.id == "increase-opacity"){
                            // 		if(bl.opacity < 1){
                            // 			bl.opacity += 0.25;
                            // 		}
                            // 	}
                            // 	var layerListItem: any = event.item;
                            // 	layerListItem.actionsSections = [[
                            // 		{
                            // 			title: "Increase opacity",
                            // 			className: "esri-icon-up",
                            // 			id: "increase-opacity"
                            // 		},
                            // 		{
                            // 			title: "Opacity: " + bl.opacity*100 + "%"
                            // 		},
                            // 		{
                            // 			title: "Decrease opacity",
                            // 			className: "esri-icon-down",
                            // 			id: "decrease-opacity"
                            // 		}
                            // 	]];
                            // });
                            // view.ui.add(legendExpand, legendPosition);
                            view.ui.add(printExpand, legendPosition);
                            //view.ui.add(basemapLayerListExpand, "bottom-left");
                            // view.ui.add(sketchExpand, legendPosition);
                            // view.ui.add(measurementExpand, legendPosition);
                            // view.ui.add(basemapGalleryExpand, legendPosition);
                            window["sketchWidget"] = sketchContent_1;
                            // window["measureWidget"] = measurementContent;
                        }
                        else if (propertyName === "legendOpenAtStart" && node) {
                            node.expanded = legendOpenAtStart;
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    exports.addLegend = addLegend;
    function addScaleBar(props) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var view, portal, config, propertyName, scalebar, scalebarPosition, ScaleBar, node;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        view = props.view, portal = props.portal, config = props.config, propertyName = props.propertyName;
                        scalebar = config.scalebar, scalebarPosition = config.scalebarPosition;
                        return [4 /*yield*/, new Promise(function (resolve_15, reject_15) { require(["esri/widgets/ScaleBar"], resolve_15, reject_15); }).then(tslib_1.__importStar)];
                    case 1:
                        ScaleBar = _a.sent();
                        node = _findNode("esri-scale-bar");
                        if (!scalebar) {
                            if (node)
                                view.ui.remove(node);
                            return [2 /*return*/];
                        }
                        // move the node if it exists 
                        if (propertyName === "scalebarPosition" && node) {
                            view.ui.move(node, scalebarPosition);
                        }
                        else if (propertyName === "scalebar") {
                            view.ui.add(new ScaleBar.default({
                                view: view,
                                unit: (portal === null || portal === void 0 ? void 0 : portal.units) === "metric" ? portal === null || portal === void 0 ? void 0 : portal.units : "non-metric",
                                style: "ruler"
                            }), scalebarPosition);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    exports.addScaleBar = addScaleBar;
    function _findNode(className) {
        var mainNodes = document.getElementsByClassName(className);
        var node = null;
        for (var j = 0; j < mainNodes.length; j++) {
            node = mainNodes[j];
        }
        return node ? node : null;
    }
    function defineActions(event) {
        // The event object contains an item property.
        // is is a ListItem referencing the associated layer
        // and other properties. You can control the visibility of the
        // item, its title, and actions using this object.
        var item = event.item;
        if (item.visible == true) {
            // An array of objects defining actions to place in the LayerList.
            // By making this array two-dimensional, you can separate similar
            // actions into separate groups with a breaking line.
            item.actionsSections = [
                // [
                // 	{
                // 		title: "Go to full extent",
                // 		className: "esri-icon-zoom-out-fixed",
                // 		id: "full-extent"
                // 	},
                // 	{
                // 		title: "Layer information",
                // 		className: "esri-icon-description",
                // 		id: "information"
                // 	}
                // ],
                [
                    {
                        title: "Increase opacity",
                        className: "esri-icon-up",
                        id: "increase-opacity"
                    },
                    {
                        title: "Opacity: " + item.layer.opacity * 100 + "%"
                    },
                    {
                        title: "Decrease opacity",
                        className: "esri-icon-down",
                        id: "decrease-opacity"
                    }
                ]
            ];
        }
        item.children = [];
    }
    function identifyFeatures(url, geometry, layerIds, extent) {
        var identifyParams = new IdentifyParameters_1.default();
        identifyParams.tolerance = 1;
        identifyParams.returnGeometry = true;
        identifyParams.layerIds = layerIds;
        identifyParams.layerOption = "all";
        identifyParams.geometry = geometry;
        identifyParams.mapExtent = extent;
        var identifyTask = new IdentifyTask_1.default({ "url": url });
        return identifyTask.execute(identifyParams).then(function (results) {
            return results;
        }, function (error) {
            console.error(error);
            return Promise.reject(error.message || error);
        });
    }
    function sketchCompleted(sketchContent, event, view) {
        var _a;
        if (!view.popup) {
            view.popup = new Popup_1.default();
        }
        view.popup.open({
            title: "",
            content: "Please wait...",
            location: event.graphic.geometry.type == "point" ? event.graphic.geometry : event.graphic.geometry.type == "polygon" ? event.graphic.geometry.centroid : event.graphic.geometry.getPoint(0, 0)
        });
        (_a = view === null || view === void 0 ? void 0 : view.graphics) === null || _a === void 0 ? void 0 : _a.removeAll();
        if (sketchContent.layer.graphics.length > 1) {
            sketchContent.layer.graphics.removeMany(sketchContent.layer.graphics.filter(function (g) { return g !== event.graphic; }));
        }
        var zoningLayersLayer = view.map.allLayers.find(function (x) { return x.title == "Zoning Layers"; });
        var subLayersIDs = zoningLayersLayer.sublayers.map(function (y) { return y.id; }).toArray();
        var identifyRsultsPromise = identifyFeatures(zoningLayersLayer.url, event.graphic.geometry, subLayersIDs, view.extent);
        identifyRsultsPromise.then(function (results) {
            var distinctSubLayerNames = [];
            results.results.forEach(function (element) {
                if (distinctSubLayerNames.indexOf(element.layerName) == -1) {
                    distinctSubLayerNames.push(element.layerName);
                }
            });
            var queryPromises = [];
            distinctSubLayerNames.forEach(function (subLayerName) {
                var _a, _b, _c;
                var idFeaturesSubset = results.results.filter(function (r) { return r.layerName == subLayerName; });
                var featGeomType = (_c = (_b = (_a = idFeaturesSubset[0]) === null || _a === void 0 ? void 0 : _a.feature) === null || _b === void 0 ? void 0 : _b.geometry) === null || _c === void 0 ? void 0 : _c.type;
                var objectIDsArray = [];
                idFeaturesSubset.forEach(function (element) {
                    objectIDsArray.push(element.feature.attributes["OBJECTID"]);
                });
                var objectIDsWhereClause = "OBJECTID IN (" + objectIDsArray.join(",") + ")";
                var subLayer = zoningLayersLayer.sublayers.find(function (s) { return s.title == subLayerName; });
                var sublayerQuery = subLayer.createQuery();
                sublayerQuery.where = objectIDsWhereClause;
                if (featGeomType == "polygon") {
                    sublayerQuery.spatialRelationship = 'intersects';
                    sublayerQuery.geometry = event.graphic.geometry;
                }
                sublayerQuery.returnGeometry = true;
                sublayerQuery.outFields = ["*"];
                queryPromises.push(subLayer.queryFeatures(sublayerQuery).then(function (results) { return promiseUtils_2.resolve({ features: results.features }); }));
            });
            Promise.all(queryPromises).then(function (allResults) {
                var allFeatures = [];
                allResults.forEach(function (result) {
                    result.features.forEach(function (feature) {
                        allFeatures.push(feature);
                    });
                });
                var projectPromises = [];
                //var allProjectedFeatures = [];
                allFeatures.forEach(function (feature) {
                    var _a, _b;
                    if (((_a = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _a === void 0 ? void 0 : _a.type) == "point") {
                        projectPromises.push(geometryUtils_1.projectPoint(feature.geometry, view.spatialReference).then(function (projectedPoint) {
                            feature.geometry = projectedPoint;
                            return promiseUtils_2.resolve({ projectedFeature: feature });
                        }));
                    }
                    else if (((_b = feature === null || feature === void 0 ? void 0 : feature.geometry) === null || _b === void 0 ? void 0 : _b.type) == "polygon") {
                        projectPromises.push(geometryUtils_2.projectPolygon(feature.geometry, view.spatialReference).then(function (projectedPolygon) {
                            feature.geometry = projectedPolygon;
                            return promiseUtils_2.resolve({ projectedFeature: feature });
                        }));
                    }
                });
                Promise.all(projectPromises).then(function (allProjectedFeatures) {
                    var alp = allProjectedFeatures.map(function (x) { return x.projectedFeature; });
                    var popupWindowLocation;
                    if (event.graphic.geometry.type == "point") {
                        popupWindowLocation = event.graphic.geometry;
                    }
                    else if (event.graphic.geometry.type == "polygon") {
                        popupWindowLocation = event.graphic.geometry.centroid;
                    }
                    else if (event.graphic.geometry.type == "polyline") {
                        popupWindowLocation = new geometry_1.Point({ x: event.graphic.geometry.paths[0][0][0], y: event.graphic.geometry.paths[0][0][1], spatialReference: view.spatialReference });
                    }
                    view.popup.open({
                        features: alp,
                        location: popupWindowLocation
                    });
                });
            });
        });
    }
});
//# sourceMappingURL=esriWidgetUtils.js.map